export enum RegistrationFieldId {
  // Basic Information
  IsLegal = 1,
  Email = 2,
  EconomicCode = 3,

  // Personal Information
  NationalId = 20,
  BirthDate = 21,
  FirstName = 22,
  LastName = 23,
  FatherName = 24,
  IsMale = 25,
  CertificateNo = 26,
  NationalCardUploadedId = 27,

  // Legal Entity (Company) Information
  CompanyName = 40,
  CompanyNationalId = 41,
  CompanyType = 42,
  RegistrationNumber = 43,
  GazetteUploadedId = 46,
  BusinessName = 47,

  // Address Information
  PostalCode = 60,
  ProvinceId = 61,
  CityId = 62,
  Avenue = 63,
  Alley = 64,
  Plaque = 65,
  PhoneNumber = 66,
}
